import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import twoLogosWhite from "../images/twoLogosWhite.svg";
import { useBasket } from "../context/BasketContext";

const menuItems = [
    {
        label: "Сторінки",
        items: [
            { label: "Кошик", path: "/basket", icon: "pi-shopping-cart", showBadge: true },
            { label: "Домашня сторінка", path: "/", icon: "pi-home" },
            { label: "Каталог", path: "/catalog", icon: "pi-th-large" },
            { label: "Обмін", path: "/exchange", icon: "pi-sync" },
        ],
    },
    {
        label: "Колекції",
        items: [
            { label: "Diamonds", path: "/diamonds", icon: "pi-heart" },
            { label: "Billion", path: "/billion", icon: "pi-star" },
            { label: "Kolorovi", path: "/kolorovi", icon: "pi-palette" },
            { label: "AirGold", path: "/air-gold", icon: "pi-sun" },
            { label: "Vidrodzhennya", path: "/vidrodzhennya", icon: "pi-bolt" },
            { label: "Harmony", path: "/harmony", icon: "pi-moon" },
            { label: "Reflect", path: "/reflect", icon: "pi-sparkles" },
        ],
    },
    {
        label: "Інше",
        items: [
            // { label: "Про нас", path: "/about-us", icon: "pi-info-circle" },
            { label: "Доставка", path: "/delivery", icon: "pi-truck" },
        ],
    },
];

function NavigationDrawer({ isOpen, onClose }) {
    const navigate = useNavigate();
    const { getTotalItems } = useBasket();
    const basketCount = getTotalItems();

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener("keydown", handleEscape);
        }

        return () => {
            document.removeEventListener("keydown", handleEscape);
        };
    }, [isOpen, onClose]);

    const handleNavigate = (path) => {
        navigate(path);
        onClose();
    };

    return (
        <>
            {/* Backdrop */}
            <div
                className={`fixed inset-0 bg-black transition-opacity duration-300 z-[60] ${
                    isOpen
                        ? "opacity-50 pointer-events-auto"
                        : "opacity-0 pointer-events-none"
                }`}
                onClick={onClose}
            />

            {/* Drawer */}
            <div
                className={`fixed top-0 right-0 h-full w-full sm:w-96 bg-darkgray text-white z-[70] transform transition-transform duration-300 ease-out ${
                    isOpen ? "translate-x-0" : "translate-x-full"
                }`}
            >
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b border-gray-700">
                    <img
                        src={twoLogosWhite}
                        alt="TSATSKY"
                        className="h-10"
                    />
                    <button
                        onClick={onClose}
                        className="p-2 rounded-full hover:bg-white hover:bg-opacity-10 transition-all duration-200"
                        aria-label="Close menu"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>

                {/* Menu Sections */}
                <div className="overflow-y-auto h-[calc(100%-72px)] py-4">
                    {menuItems.map((section, sectionIndex) => (
                        <div key={sectionIndex} className="mb-6">
                            <div className="px-6 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider">
                                {section.label}
                            </div>
                            <div className="px-2">
                                {section.items.map((item, itemIndex) => (
                                    <button
                                        key={itemIndex}
                                        onClick={() => handleNavigate(item.path)}
                                        className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-white hover:bg-opacity-10 rounded-lg transition-all duration-200 group"
                                    >
                                        <div className="flex items-center gap-3">
                                            <i
                                                className={`pi ${item.icon} text-white group-hover:scale-110 transition-transform duration-200`}
                                            />
                                            <span className="text-base">
                                                {item.label}
                                            </span>
                                        </div>
                                        {item.showBadge && basketCount > 0 && (
                                            <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full font-medium">
                                                {basketCount}
                                            </span>
                                        )}
                                    </button>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default NavigationDrawer;
